import {
  pendingEachOrder,
  listPendingOrder,
  setOrderDelay,
  restoreOrder,
  listIncomingOrder,
  listOutsideOrder,
  acceptOrder,
  rejectOrder,
  reasonList,
} from '@/api/handleOrder';
import { orderInfo } from '@/api/order';

export default {
  namespaced: true,
  state: {
    pageItem: 12,
    pending: [],
    valid: [],
    invalid: [],
    reason_list: [],
    valid_outside: [],
    invalid_outside: [],
  },

  getters: {
    getPageItem: (state) => state.pageItem,
    getPendingOrder: (state) => state.pending,
    getValidIncomingOrder: (state) => state.valid,
    getInvalidIncomingOrder: (state) => state.invalid,
    getReasonList: (state) => state.reason_list,
    getValidOutsideOrder: (state) => state.valid_outside,
    getInvalidOutsideOrder: (state) => state.invalid_outside,
  },

  mutations: {
    SET_PENDING_LIST(state, data) {
      state.pending = data;
    },
    SET_VALID_LIST(state, data) {
      state.valid = data;
    },
    SET_INVALID_LIST(state, data) {
      state.invalid = data;
    },
    SET_REASON_LIST(state, data) {
      state.reason_list = data;
    },
    SET_VALID_OUTSIDE_LIST(state, data) {
      state.valid_outside = data;
    },
    SET_INVALID_OUTSIDE_LIST(state, data) {
      state.invalid_outside = data;
    },
    REMOVE_INCOMING_ORDER(state, order_id) {
      const index = state.valid.findIndex((el) => el.order_id === order_id);
      state.valid.splice(index, 1);
    },
    REMOVE_OUTSIDE_ORDER(state, order_id) {
      const index = state.valid_outside.findIndex((el) => el.order_id === order_id);
      state.valid_outside.splice(index, 1);
    },
    RESET(state) {
      state.pending = [];
      state.valid = [];
      state.invalid = [];
      state.valid_outside = [];
      state.invalid_outside = [];
      state.reason_list = [];
    },
  },

  actions: {
    //單一訂單掛單
    async doPendingEachOrder({ rootGetters, dispatch }, payload = {}) {
      const order_id = rootGetters['order/getOrderId'];
      const card_number = rootGetters['member/getWantCardNo'] || null;
      const tax = rootGetters['checkout/getTax'];
      const invoiceMode = rootGetters['checkout/getInvoiceMode'];
      const carrier = rootGetters['checkout/getCarrier'];
      console.debug("doPendingEachOrder tax=", tax, "invoiceMode=", invoiceMode , "carrier=", carrier);
      const payload2 = {
        order_id: rootGetters['order/getOrderId'],
        buyer_tax_id: rootGetters['checkout/getTax'],
        invoice_mode: rootGetters['checkout/getInvoiceMode'],
        card_number: rootGetters['member/getWantCardNo'] || null,
        carrier: rootGetters['checkout/getCarrier'],
      };

      const { status } = await pendingEachOrder(payload2);
      if (!status) return;
      dispatch('system/getEcho', '', { root: true });
      return Promise.resolve();
    },
    //取得掛單列表
    async doGetPendingOrderList({ commit }) {
      const res = await listPendingOrder();
      commit('SET_PENDING_LIST', res.order_list);
      return Promise.resolve();
    },
    //取得有效內部訂單列表
    async doGetValidIncomingOrderList({ commit }) {
      const res = await listIncomingOrder(1);
      commit('SET_VALID_LIST', res.order_list);
      return Promise.resolve();
    },
    //取得失效內部訂單列表
    async doGetInvalidIncomingOrderList({ commit }) {
      const res = await listIncomingOrder(2);
      commit('SET_INVALID_LIST', res.order_list);
      return Promise.resolve();
    },
    //取得有效外部訂單列表
    async doGetValidOutsideOrderList({ commit }) {
      const res = await listOutsideOrder(1);
      commit('SET_VALID_OUTSIDE_LIST', res.order_list);
      return Promise.resolve();
    },
    //取得失效外部訂單列表(目前沒有使用到)
    async doGetInvalidOutsideOrderList({ commit }) {
      const res = await listOutsideOrder(2);
      commit('SET_INVALID_OUTSIDE_LIST', res.order_list);
      return Promise.resolve();
    },
    //查看訂單
    async doGetOrderInfo(context, order_id) {
      const res = await orderInfo(order_id);
      return Promise.resolve(res);
    },
    //延遲訂單
    async doSetOrderDelay(context, data) {
      await setOrderDelay(data);
      return Promise.resolve();
    },
    //接單
    async doAcceptOrder({ commit }, data) {
      await acceptOrder(data.order_id);
      if (data.source == 'inner') commit('REMOVE_INCOMING_ORDER', data.order_id);
      if (data.source == 'outside') commit('REMOVE_OUTSIDE_ORDER', data.order_id);
      return Promise.resolve();
    },
    //拒單
    async doRejectOrder({ commit }, data) {
      await rejectOrder(data);
      if (data.source == 'outside') {
        commit('REMOVE_OUTSIDE_ORDER', data.order_id);
      } else {
        commit('REMOVE_INCOMING_ORDER', data.order_id);
      }
      return Promise.resolve();
    },
    //取得系統拒單/延單原因列表
    async doReasonList({ commit }) {
      let list = await reasonList();
      commit('SET_REASON_LIST', list);
      return Promise.resolve();
    },

    //取回訂單
    async dorRestoreOrder({ dispatch, commit }, order_id) {
      const { order, sell_product } = await restoreOrder(order_id);
      const {
        order_id: restored_order_id,
        information,
        promotion,
        transaction,
        invoice_info,
        payment,
        permission,
        cart,
        card_info,
        member_card,
      } = order;

      const { menu, products, addon_list, discount_list, ticket_list } = sell_product;
      const data = {
        order_id: restored_order_id,
        information,
        promotion,
        transaction,
        invoice_info,
        payment,
        permission,
        cart,
        card_info,
        member_card,
        menu,
        products,
        addon_list,
        discount_list,
        ticket_list,
      };

      await dispatch('order/doUpdateData', data, { root: true });

      if (information && information?.member_phone && information?.member_phone.length >= 10) {
        commit('member/SET_MEMBER_PHONE', information.member_phone, { root: true });
        await dispatch(
          'member/doQueryMemberInfoByPhone',
          {
            order_id: restored_order_id,
            cell_phone: information?.member_phone,
          },
          { root: true }
        );
      }
      //250324備註:大苑子那邊還沒確定原本的旺卡在恢復訂單時要不要也帶入電子券
      //所以暫時先註解掉這行，等確定再打開。
      // else {
      //   // 原有的票券查詢邏輯
      //   if (member_card && member_card.tel) {
      //     ticket = await getMemberTicketByPhone({ order_id: order_id, cell_phone: member_card.tel });
      //   }
      // }

      return Promise.resolve();
    },
  },
};
